import { render, staticRenderFns } from "./TypeOfHeatingFormField.vue?vue&type=template&id=01fc72ef"
import script from "./TypeOfHeatingFormField.vue?vue&type=script&lang=js"
export * from "./TypeOfHeatingFormField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports